import type { InterpretedFilters, Catalog } from '../ask/interpret';
import { describeSeen, signalLabels } from '../search/state';
import { cn } from '../ui/cn';
import { osLabel, statusMeta } from '../ui/status';

const kindLabel = { all: 'All records', device: 'Devices', organization: 'Customers', site: 'Sites' } as const;
const sortLabel = { relevance: 'Best match first', title: 'By name', status: 'Most severe first', lastSeenAt: 'By check-in', updatedAt: 'By update' } as const;

/** One-line, chip-style description of a set of filters. */
export function summaryParts(filters: InterpretedFilters, catalog: Catalog) {
  const name = (list: Array<{ id: string; title: string }>, id: string) => list.find(x => x.id === id)?.title ?? 'Unknown';
  const parts: string[] = [kindLabel[filters.kind]];
  if (filters.org.length) parts.push(filters.org.map(id => name(catalog.organizations, id)).join(' or '));
  if (filters.site.length) parts.push(`Site ${filters.site.map(id => name(catalog.sites, id)).join(' or ')}`);
  if (filters.status.length) parts.push(filters.status.map(s => statusMeta[s].label).join(' or '));
  if (filters.os.length) parts.push(filters.os.map(o => osLabel(o) ?? 'Unknown OS').join(' or '));
  if (filters.seen) parts.push(describeSeen(filters.seen).label);
  if (filters.signal.length) parts.push(filters.signal.map(s => signalLabels[s]).join(' or '));
  if (filters.duplicateName) parts.push('Duplicate names within a customer');
  if (filters.software) parts.push(`Has “${filters.software}”`);
  if (filters.q) parts.push(`“${filters.q}”`);
  if (filters.sort) parts.push(sortLabel[filters.sort.field]);
  return parts;
}

export function FilterSummary({ filters, catalog, className }: { filters: InterpretedFilters; catalog: Catalog; className?: string }) {
  return (
    <span className={cn('flex flex-wrap items-center gap-1', className)}>
      {summaryParts(filters, catalog).map((part, i) => (
        <span key={i} className={cn('rounded-md px-1.5 py-px text-[12.5px] font-medium', i === 0 ? 'bg-brand-soft text-brand-ink' : 'bg-sunken text-ink-2')}>{part}</span>
      ))}
    </span>
  );
}
